import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=22221419&scoped=true&"
import script from "./Accounts.vue?vue&type=script&lang=js&"
export * from "./Accounts.vue?vue&type=script&lang=js&"
import style0 from "./Accounts.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Accounts.vue?vue&type=style&index=1&id=22221419&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22221419",
  null
  
)

export default component.exports